// extracted by mini-css-extract-plugin
module.exports = {"debug":"listCompanies_debug__1yyZn","listContainer":"listCompanies_listContainer__24fg7","containerInput":"listCompanies_containerInput__QQ81f"};